import React from "react";
import ProductImage1 from "../assets/product/product1.webp";
import ProductImage3 from "../assets/product/product3.webp";
import OneMonth from "../assets/product/1m-new.webp";
import ThreeMonth from "../assets/product/3m-new.webp";
import SixMonth from "../assets/product/6m-new.webp";
import Ingredients from "../assets/product/tryonce.webp";
import { Icon } from "./elements/icon";
import { useTranslation } from "react-i18next";
import {
  Box1mLine1,
  Box1mLine2,
  Box3mLine1,
  Box6mLine1,
  Box6mLine3,
  ChooseYourPlan,
  TryOnce,
  MonthlyPlan,
  ThreeMonthPlan,
  Save10Percent,
  Save25Percent,
  StartNowButton,
  PerDay,
  Month,
  TryOnceBox1,
  TryOnceBox2,
  TryOnceBox3,
  Reformulation,
  Free,
  Shipping,
  NutritionistAccess,
  WelcomeKit,
  AndMore,
  YouAre,
  Saving,
  InAverage,
  WhatAreYouGetting,
  FreeShippingMobile,
  CancelAnytimeMobile,
  FreeShippingInEu,
} from "../Constants";
import GuaranteeImg from "../assets/Guarantee.webp";
import GiftImg from "../assets/Gift.webp";
import TickImg from "../assets/FreeShippingTick.webp";

const MobileSubscriptionCard = ({
  username,
  subscribtion = {},
  subs = [],
  onSelectPlan,
  totals = {},
  paymentLink,
  onSubmitData,
  error = {},
  showBtn = true,
  boxRef,
  focusArea,
  totalIngredients,
}) => {
  const { t } = useTranslation();
  const { duration = "" } = subscribtion;

  const getBannerImage = () => {
    switch (duration) {
      case "6 months":
        return SixMonth;
      case "3 months":
        return ThreeMonth;
      default:
        return OneMonth;
    }
  };

  const getProductImage = () => {
    switch (duration) {
      case "6 months":
        return ProductImage3;
      case "3 months":
        return ProductImage1;
      default:
        return Ingredients;
    }
  };

  const getPrice = () => {
    switch (duration) {
      case "6 months":
        return Math.round(parseFloat(totals.sixMonths || 0));
      case "3 months":
        return Math.round(parseFloat(totals.threeMonths || 0));
      default:
        return Math.round(parseFloat(totals.oneMonth || 0));
    }
  };

  const getPerDay = () => (getPrice() / 30).toFixed(2);

  const showStrikeThrough = ["6 months", "3 months"].includes(duration);
  const disabledBtn = !paymentLink || Object.values(error).some(Boolean);

  const twoFocusArea = focusArea?.slice(0, 2).map((item) => item?.answer);

  const tickList = [
    {
      durations: ["6 months"],
      text: t(Box6mLine1)?.replace("{0}", totalIngredients),
    },
    {
      durations: ["3 months"],
      text: t(Box3mLine1)?.replace("{0}", totalIngredients),
    },
    {
      durations: ["1 month"],
      text: t(Box1mLine1),
    },
    {
      durations: ["30 days"],
      text: t(TryOnceBox1),
    },
    ...(twoFocusArea
      ? [
          {
            durations: ["6 months", "3 months"],
            text:
              t(TryOnceBox3) +
              (twoFocusArea?.map((item) => " " + item).join("") || "") +
              " " +
              t(AndMore),
          },
        ]
      : []),
    {
      durations: ["1 month"],
      text: t(Box1mLine2),
    },
    {
      durations: ["30 days"],
      text: t(TryOnceBox2),
    },
    {
      durations: ["6 months", "3 months"],
      text: t(Box6mLine3),
    },
    ...(twoFocusArea
      ? [
          {
            durations: ["30 days"],
            text:
              t(TryOnceBox3) +
              twoFocusArea?.map((item) => " " + item) +
              " " +
              t(AndMore),
          },
        ]
      : []),
  ];

  return (
    <div className="sm:t-hidden t-relative !t-w-full t-bg-white !t-max-w-[500px] t-flex t-flex-col t-px-2 md:t-px-4 t-py-4 md:t-py-6 t-border t-border-gry-200 t-rounded-lg t-gap-2">
      <div className="t-flex t-flex-row t-gap-4">
        <div className="t-flex t-flex-col t-items-start t-justify-between t-gap-4">
          <p className="t-m-0 t-font-[700] t-text-2xl">{username}'s mix</p>
          <img
            src={getBannerImage()}
            alt=""
            className={duration === "30 days" ? "t-h-[48px] t-w-[150px]" : ""}
          />
          <p className="t-m-0 t-font-bold t-text-lg">{t(ChooseYourPlan)}</p>
        </div>
        <img
          src={getProductImage()}
          alt=""
          className={`${
            ["6 months", "3 months", "1 month"].includes(subscribtion?.duration)
              ? "!t-h-[155px] !t-w-[155px] object-contain"
              : "!t-h-[155px] !t-w-[155px] object-contain"
          } t-w-[40%]`}
          // className="!t-h-[155px] object-contain t-w-[40%]"
        />
      </div>
      <div className="t-flex t-gap-2 t-justify-center !t-items-stretch">
        {subs?.slice(0, 3).map((item, key) => (
          <button
            key={"mobile-sub-card-" + item.id}
            className={`t-flex-none !t-w-[30%] t-text-center t-py-1 t-rounded-lg t-border t-border-gry-200 t-text-sm t-font-bold ${
              subscribtion?.subId === item?.id
                ? "t-text-white t-bg-quaternary"
                : "t-text-gray-500 t-bg-white"
            }`}
            onClick={() => onSelectPlan(item)}
          >
            {item.duration === "30 days"
              ? t(TryOnce)
              : item.duration === "3 months"
              ? t(MonthlyPlan)
              : t(ThreeMonthPlan)}
            {item.duration === "6 months" && (
              <p
                className={`t-m-0 t-text-xs !t-font-[600] ${
                  subscribtion?.subId === item?.id
                    ? "t-text-primary"
                    : "t-text-quaternary"
                }`}
              >
                {t(Save25Percent)}
              </p>
            )}
            {item.duration === "3 months" && (
              <p
                className={`t-m-0 t-text-xs !t-font-[600] ${
                  subscribtion?.subId === item?.id
                    ? "t-text-primary"
                    : "t-text-quaternary"
                }`}
              >
                {t(Save10Percent)}
              </p>
            )}
          </button>
        ))}
      </div>
      <div className="t-flex t-items-center t-justify-center t-gap-1">
        <p className="t-m-0 t-text-xl t-font-[700] t-text-secondary t-text-center">
          {showStrikeThrough && (
            <span className="t-text-gray-400 t-line-through t-mr-2">
              {Math.round(parseFloat(totals.oneMonth || 0))}€
            </span>
          )}
          {getPrice()}€ {duration === "30 days" ? "" : "/" + t(Month)} -
        </p>
        <p className="t-text-secondary t-text-xl t-font-[700] t-mb-0 t-text-center t-m-0">
          {getPerDay()}€ {t(PerDay)}
        </p>
      </div>
      {["6 months", "3 months"].includes(duration) ? (
        <div className="t-flex t-items-center t-justify-center t-gap-8">
          {[FreeShippingMobile, CancelAnytimeMobile].map((label, i) => (
            <div className="t-flex t-items-center t-gap-2" key={i}>
              <img src={TickImg} alt="" className="t-h-4 t-w-4" />
              <p
                className="t-m-0 t-text-sm t-font-extrabold t-text-secondary"
                style={{ fontFamily: "Roboto" }}
              >
                {t(label)}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <p className="t-m-0 t-text-center">{t(FreeShippingInEu)}</p>
      )}
      {showBtn && (
        <button
          ref={boxRef}
          className="!t-text-sm !t-text-capitalize btn-custom-quaternary !t-py-2 !t-bg-secondary disabled:!t-bg-secondary hover:!t-text-white disabled:t-opacity-50 !t-rounded-lg"
          onClick={() => onSubmitData(paymentLink)}
          disabled={disabledBtn}
        >
          {t(StartNowButton)}
        </button>
      )}
      <p className="t-m-0">
        {t(WhatAreYouGetting)}{" "}
        <span
          className="t-text-extrabold t-text-secondary"
          style={{ fontFamily: "roboto" }}
        >
          {getPerDay()}€
        </span>{" "}
        {t(PerDay)}:
      </p>
      <div className="t-flex t-flex-col !t-gap-2">
        {tickList
          .filter(({ durations }) => durations.includes(duration))
          .map((item, idx) => (
            <div className="t-flex t-items-start t-gap-2" key={idx}>
              <Icon name="tick" size="16" className="t-mt-1" />
              <p className="t-text-sm t-mb-0">{item.text}</p>
            </div>
          ))}

        {duration !== "30 days" && (
          <>
            {[
              { old: "6€", label: Shipping },
              { old: "20€", label: NutritionistAccess },
              { old: "10€", label: WelcomeKit },
            ].map(({ old, label }, idx) => (
              <div className="t-flex t-items-start t-gap-2" key={idx}>
                <img src={GiftImg} alt="gift" className="t-w-4 t-h-4" />
                <p className="t-text-sm t-mb-0">
                  <span
                    className="t-line-through"
                    style={{ fontFamily: "roboto" }}
                  >
                    {old}
                  </span>{" "}
                  <span
                    className="t-text-extrabold"
                    style={{ fontFamily: "roboto" }}
                  >
                    {t(Free)}
                  </span>{" "}
                  {t(label)}
                </p>
              </div>
            ))}
          </>
        )}

        <div className="t-flex t-items-start t-gap-2">
          <img src={GuaranteeImg} alt="guarantee" className="t-w-4 t-h-4" />
          <p className="t-text-sm t-mb-0">{t(Reformulation)}</p>
        </div>
        <p className="!t-m-0 t-p-2 t-bg-gray-100 t-rounded-lg t-text-center">
          {t(YouAre)}{" "}
          <span
            className="t-text-extrabold t-text-secondary"
            style={{ fontFamily: "roboto" }}
          >
            {t(Saving)} 34%
          </span>{" "}
          {t(InAverage)}
        </p>
      </div>
    </div>
  );
};

export default MobileSubscriptionCard;
